/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var headFoot = __webpack_require__(1);
	    var lazyload = __webpack_require__(10);
	    var tapEvent = __webpack_require__(13);
	    var goTop = __webpack_require__(2);
	    var price = __webpack_require__(20);
	    var bottomCatSwiper = __webpack_require__(43);
	
	    headFoot.loadHeadAndFooter();
	    price.fn.getPrice();
	    tapEvent.tapItem();
	    tapEvent.tapSale();
	    tapEvent.tapLink();
	    goTop.fn.init();
	    bottomCatSwiper.init();
	    lazyload.fn.init();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var jdHeaderAndFooter = {
	        init: function init() {
	            var u = navigator.userAgent.toLowerCase();
	
	            // jdhapp 京东健康
	            if (u.indexOf("jdapp") != -1 || u.indexOf("jdjr") != -1 || u.indexOf("kepler") != -1 || u.indexOf("micromessenger") != -1 || u.indexOf("jdhapp") != -1 || u.indexOf("yhdapp") != -1 || u.indexOf("mxxqapp") != -1) {
	                return false;
	            }
	
	            var param = new Object();
	            var sid = $("#sid").val();
	            var title = $("#title").val();
	            var link = $("#link").val();
	            var mchb = new MCommonHeaderBottom();
	
	            if (null != sid && sid.length > 0) {
	                param.sid = sid;
	            }
	            if (null != title && title.length > 0) {
	                param.title = title;
	            }
	            if (null != link && link.length > 0) {
	                param.link = link;
	            }
	
	            //加载头部
	            // if(location.href.indexOf("jd.hk") > -1) {
	            //     var tpl = require("../../template/header");
	            //     var render = template.compile(tpl.tpl);
	            //     var html = render({});
	            //     $("#m_common_header").append(html);
	            // } else {
	            var headerArg = { hrederId: 'm_common_header', title: title, sid: sid, isShowShortCut: false, selectedShortCut: '4' };
	            mchb.header(headerArg);
	            // }
	            $(".header").css("border-top", "0");
	        }
	    };
	    exports.loadHeadAndFooter = jdHeaderAndFooter.init;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var goTop = {
	        f: [],
	        init: function init() {
	            var self = this;
	            self.render();
	            self.handleGoTop();
	
	            if (self.isScroll()) {
	                $("#goTop").removeClass("hide");
	            }
	        },
	        render: function render() {
	            var goTopDiv = $('<div id="goTop" class="hide"></div>');
	            $(".viewport").append(goTopDiv);
	        },
	        handleGoTop: function handleGoTop() {
	            var self = this;
	            $("#goTop").on("tap", function () {
	                document.body.scrollTop = 0;
	                $("#goTop").addClass("hide");
	            });
	            if (typeof jQuery != "undefined") {
	                jQuery.noConflict();
	            }
	            $("body").on("touchstart", function (e) {
	                self.f.startX = e.touches[0].clientX;
	                self.f.endX = e.touches[0].clientX;
	                self.f.prevX = self.f.startX;
	                self.f.prevY = e.touches[0].clientY;
	            }).on("touchend", function (e) {
	                setTimeout(function () {
	                    if (document.body.scrollTop <= 0) {
	                        $("#goTop").addClass("hide");
	                    } else {
	                        $("#goTop").removeClass("hide");
	                    }
	                }, 400);
	            }).on("touchcancel", function (e) {
	                setTimeout(function () {
	                    if (document.body.scrollTop <= 0) {
	                        $("#goTop").addClass("hide");
	                    } else {
	                        $("#goTop").removeClass("hide");
	                    }
	                }, 400);
	            });
	        },
	        isScroll: function isScroll() {
	            if (document.body.scrollTop > 0) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    };
	    exports.fn = goTop;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = {
	        debug: false,
	        lock: false,
	        scrollEnd: 0
	    };
	
	    Config.serviceInterface = {
	        getZyLoadMore: "//jdw.jd.hk/zy/getCateSkuData.do",
	        getSearchData: "//jdw.jd.hk/search/list.do",
	        getSelfAttr: "//jdw.jd.hk/search/getSelfAttrBySkuId.do",
	        getCateBranch: "//jdw.jd.hk/category/getCategoryDataById.do",
	        getPrice: "//pm.3.cn/prices/mgets",
	        getPcpPrice: "//pm.3.cn/prices/pcpmgets?",
	        getTime: "//jdw.jd.hk/getTime.do",
	        IndexScrollToLoadMore: "//jdw.jd.hk/getCategoryData.do",
	        getSeckillStock: "//jdw.jd.hk/getStockBySkuId.do",
	        getGoodsFromConfig: "//jdw.jd.hk/classbaby/getClassBabyDataById.do?",
	        searchGoodsByCat: "//jdw.jd.hk/search/list.do",
	        searchGoodsByCatJsonp: "//jdw.jd.hk/search/listForJsonp.do",
	        getTopManCate: "//jdw.jd.hk/recommend/getData.do",
	        getTopManItem: "//jdw.jd.hk/recommend/getSkuInfo.do",
	        getReadPv: "//jdw.jd.hk/recommend/getPv.do",
	        doGrunt: "//jdw.jd.hk/user/doGrant.do",
	        uploadImg: "//jdw.jd.hk/clearance/uploadWaterMarkImg.do",
	        getFlagImg: "//jdw.jd.hk/choose/getFlagImgBySkuIds.do",
	        getCommentNum: "//jdw.jd.hk/choose/getGoodCount.do",
	        getCategorySkus: "//jdw.jd.hk/chooseclz/getCategorySkus.do",
	        attentionItem: "//follow-soa.jd.com/rpc/product/follow",
	        unAttentionItem: "//follow-soa.jd.com/rpc/product/unfollow",
	        isAttentionItems: "//follow-soa.jd.com/rpc/product/batchIsFollow",
	        isLogin: "//jdw.jd.hk/lieshou/isLogin.do",
	        productFollow: "//jdw.jd.hk/choose/productFollow.do",
	        getComponentInfo: "//jicc-web.jd.com/api/component/getComponentInfo/m",
	        getComponentInfoWQ: "//jicc-web.jd.com/api/component/getComponentInfo/wq",
	        uploadImage: "//jicc-web.jd.com/api/component/uploadImage/m",
	        uploadImageWQ: "//jicc-web.jd.com/api/component/uploadImage/wq",
	        saveImage: "//jicc-web.jd.com/api/component/save/m",
	        saveImageWQ: "//jicc-web.jd.com/api/component/save/wq",
	        // checkUploadNameWQ: "//jdw.jd.hk/clearance/checkUploadName.do",
	        checkUploadNameWQ: "//global.m.jd.com/clearance/checkUploadName.do",
	        checkUploadName: "//global.m.jd.com/clearance/checkUploadName.do",
	        newCheckUploadNameWQ: "//jdw.jd.hk/clearance/checkUploadNameNew.do",
	        newCheckUploadName: "//global.m.jd.com/clearance/checkUploadNameNew.do"
	    };
	
	    Config.validators = {
	        idCard: {
	            regExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
	            errorMsg: "请填写正确的18位身份证号码"
	        }
	    };
	
	    module.exports = Config;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var lazyload = {
	        init: function init(opt) {
	            var that = this;
	            var op = {
	                anim: true
	            };
	            $.extend(op, opt);
	            that.img.init(op);
	        },
	        img: {
	            init: function init(n) {
	
	                var that = this;
	
	                function inViewport(el) {
	                    var top = window.pageYOffset;
	                    var btm = window.pageYOffset + window.innerHeight;
	                    var elTop = $(el).offset().top;
	                    var elBtm = elTop + $(el).height() + 100;
	                    if (elBtm >= top && elTop <= btm) {
	                        return true;
	                    } else {
	                        return false;
	                    }
	                    // return elTop >= top && elTop <= btm
	                }
	
	                $(document).off('scroll').on('scroll', function () {
	                    $('img.lazy').each(function (index, node) {
	                        var $this = $(this);
	                        if (!$this.attr('dataimg')) {
	                            return;
	                        }
	                        if (!inViewport(this)) {
	                            return;
	                        }
	                        if ($this.parents(".tabCnt").hasClass("hide")) {
	                            return;
	                        }
	                        if ($this.parents(".floor").hasClass("hide")) {
	                            return;
	                        }
	                        act($this);
	                    });
	                }).trigger('scroll');
	
	                setTimeout(function () {
	                    $(document).trigger('scroll');
	                }, 300);
	
	                function act(_self) {
	                    if (_self.attr('loaded')) return;
	                    var img = new Image(),
	                        original = _self.attr('dataimg');
	                    img.onload = function () {
	                        _self.attr('src', original).removeClass('lazy');
	                        n.anim && _self.css({ opacity: .2 }).animate({ opacity: 1 }, 280);
	                    };
	                    original && (img.src = original);
	                    _self.attr('loaded', true);
	                }
	            }
	        }
	    };
	    exports.fn = lazyload;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tplModel = {
	        render: function render(data, tpl) {
	            var render = template.compile(tpl.tpl);
	            return render(data);
	        }
	    };
	    module.exports = tplModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var vs = __webpack_require__(14);
	    var linkParser = __webpack_require__(15);
	
	    var JDAPP = "jdapp",
	        JDJR = "jdjr",
	        BROWSER = "browser";
	
	    var tapEvent = {
	        ua: vs.ua,
	        tapItem: function tapItem(useLinkParser) {
	            var self = this;
	
	            self.handleTap(".tapItem", function (_this) {
	                if ($(_this).parents("#cj-itemsList").length > 0) {
	                    var url = location.href.split("#")[0];
	                    history.pushState({}, "", url + "#reload");
	                }
	
	                var skuid = $(_this).attr("skuid");
	                if (self.ua == JDAPP || self.ua == JDJR) {
	                    location.href = self.openApp(skuid);
	                } else if (self.ua == BROWSER) {
	                    var itemLink = vs.setVs(self.composit4MJd(skuid, "", ""));
	                    if (useLinkParser) {
	                        // 如果使用linkParser解析itemLink区分微信平台
	                        itemLink = linkParser.parse(itemLink);
	                    }
	                    location.href = itemLink;
	                }
	            });
	        },
	        tapSale: function tapSale() {
	            var self = this;
	
	            self.handleTap(".tapSale", function (_this) {
	                var href = $(_this).attr("data-href");
	
	                if (self.ua == JDAPP || self.ua == JDJR) {
	                    if (href.indexOf("sale.jd.hk/m") >= 0) {
	                        href = href.replace("sale.jd.hk/m", "sale.jd.hk/app");
	                    } else if (href.indexOf("sale.jd.com/m") >= 0) {
	                        href = href.replace("sale.jd.com/m", "sale.jd.com/app");
	                    }
	                } else if (self.ua == BROWSER) {
	                    if (href.indexOf("sale.jd.hk/app") >= 0) {
	                        href = href.replace("sale.jd.hk/app", "sale.jd.hk/m");
	                    } else if (href.indexOf("sale.jd.com/app") >= 0) {
	                        href = href.replace("sale.jd.com/app", "sale.jd.com/m");
	                    }
	                }
	
	                location.href = vs.setVs(href);
	            });
	        },
	        tapLink: function tapLink(useLinkParser) {
	            var self = this;
	
	            self.handleTap(".tapLink", function (_this) {
	                if (window.sessionStorage) {
	                    var scrollTop = $("body").scrollTop();
	                    sessionStorage.setItem("scrollTop", scrollTop);
	                }
	
	                // 激活分类京选对应的tabs
	                var $me = $(_this);
	                var $jxTabs = $me.closest('.jxTabs');
	                if ($me.hasClass('moreItem') && $jxTabs.length > 0) {
	                    var matchLink = "jdw.jd.hk/chooseclz/index.html";
	                    var link = $(_this).attr("data-href");
	                    if (link.indexOf(matchLink) !== -1) {
	                        location.href = '//' + matchLink + '?activeCateId=' + $jxTabs.find('.curr').attr('cateid');
	                        return;
	                    }
	                }
	
	                var link = vs.setVs($(_this).attr("data-href"));
	                if (useLinkParser) {
	                    // 如果使用linkParser解析link区分微信平台
	                    link = linkParser.parse(link);
	                }
	                location.href = link;
	            });
	        },
	        tapVender: function tapVender() {
	            var self = this;
	
	            self.handleTap(".tapVender", function (_this) {
	                var venderId = $(_this).data('venderId');
	                if (self.ua == JDAPP) {
	                    location.href = self.conposeVenderLink4App(venderId);
	                } else if (self.ua == BROWSER || self.ua == JDJR) {
	                    href = "//shop.m.jd.com/?shopId=" + venderId;
	                    location.href = vs.setVs(href);
	                }
	            });
	        },
	        handleTap: function handleTap(className, callback) {
	            var self = this;
	            window.canAutoScroll = true;
	            var f = [];
	            if (typeof jQuery != "undefined") {
	                jQuery.noConflict();
	            }
	
	            $(className).off("touchstart").on("touchstart", function (e) {
	                f.startX = e.touches[0].clientX;
	                f.endX = e.touches[0].clientX;
	                f.prevX = f.startX;
	                f.prevY = e.touches[0].clientY;
	                f.directionX = "";
	                f.directionY = "";
	            }).off("touchmove").on("touchmove", function (e) {
	                f.directionX = e.touches[0].clientX - f.prevX > 0 ? "right" : "left";
	                f.directionY = e.touches[0].clientY - f.prevY > 0 ? "bottom" : "top";
	            }).off("touchend").on("touchend", function (e) {
	                if (f.directionY != "top" && f.directionY != "bottom" && f.directionX != "right" && f.directionX != "left") {
	                    if ($.isFunction(callback)) {
	                        callback(this);
	                    }
	                }
	            });
	        },
	        composit4MJd: function composit4MJd(sku, actId, sid) {
	            var link = "//m.jd.com/product/";
	            link = link + sku + ".html?";
	            link = link + "resourceType=m_destination_page";
	            link = link + "&resourceValue=" + actId;
	            return link;
	        },
	        openApp: function openApp(sku) {
	            var link = 'openapp.jdMobile://virtual?params={"category":"jump","des":"productDetail","skuId":"';
	            link = link + sku;
	            link = link + '","sourceType":"m_destination_page","sourceValue":"","landPageId":""}';
	            return link;
	        },
	        conposeVenderLink4App: function conposeVenderLink4App(shopId) {
	            var link = 'openApp.jdMobile://virtual?params=';
	            link += '{"category":"jump","des":"jshopMain","shopId":"' + shopId;
	            link += '","sourceType":"","sourceValue":"", "landPageId":"jshop.cx.mobile"}';
	            return link;
	        },
	        closeWebView: function closeWebView() {
	            var ua = navigator.userAgent.toLowerCase();
	            if (ua.indexOf(JDAPP) != -1) {
	                //如果是京东app里面，根据客户端是android或者ios版本,关闭webview
	                if (/iphone|ipad|ipod/.test(ua)) {
	                    location.href = "objc:closeMPage";
	                } else if (/android/.test(ua)) {
	                    JdAndroid.finishWebActivity();
	                }
	            } else {
	                //否则哪儿跳过来的，跳回到哪儿去，没有来源就跳回首页
	                if (!document.referrer || document.referrer == "" || document.referrer == window.location.href) {
	                    // location.href = "//m.jd.hk"
	                    location.href = "//jdw.jd.hk";
	                } else {
	                    location.href = document.referrer;
	                }
	            }
	        }
	    };
	
	    module.exports = tapEvent;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var u = navigator.userAgent;
	    var ua = "browser";
	    var vs = "m";
	
	    if (u.indexOf("jdapp") != -1) {
	        ua = "jdapp";
	    } else if (u.indexOf("MicroMessenger") != -1) {
	        ua = "browser";
	        vs = "wx";
	    } else if (u.indexOf("iPad") != -1) {
	        ua = "browser";
	        vs = "pad";
	    } else if (u.indexOf("JDJR-App") != -1 || u.indexOf("kepler") != -1) {
	        ua = "jdjr";
	        vs = "jdjr";
	    } else {
	        ua = "browser";
	        vs = "m";
	    }
	
	    if (getVs() != "") {
	        vs = getVs();
	    }
	
	    function getVs() {
	        var vs = "";
	        var href = location.href;
	        if (href.indexOf("vs=") != -1) {
	            var hrefArray = href.split("vs=");
	            if (hrefArray.length > 1) {
	                var vsStr = hrefArray[1];
	                var reg = /^[a-z0-9A-Z]+/;
	                var r = vsStr.match(reg);
	
	                if (r != null) {
	                    vs = r;
	                }
	            }
	        }
	        return vs;
	    }
	
	    function setVs(str) {
	        var reg = /^\bvs=\b[a-z0-9A-Z]+/;
	        if (str.indexOf("jdw.jd.hk") != -1) {
	            if (str.indexOf("vs=") != -1) {
	                str = str.replace(reg, "vs=" + vs);
	            } else {
	                if (str.indexOf("?") != -1) {
	                    str = str + "&vs=" + vs;
	                } else {
	                    str = str + "?vs=" + vs;
	                }
	            }
	        }
	        return str;
	    }
	
	    module.exports.setVs = setVs;
	    exports.ua = ua;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	 * 根据是否是微信手Q平台，解析不同的商详链接和通天塔活动链接
	*/
	var linkParser = {
	  isWQ: function isWQ() {
	    var ua = navigator.userAgent.toLowerCase();
	    if (ua.indexOf("micromessenger") !== -1 || ua.indexOf("qq/") !== -1) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  getUrlParam: function getUrlParam(link, name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var linkArr = link.split('?');
	    if (linkArr.length > 1) {
	      var r = link.split('?')[1].match(reg);
	      if (r != null) return r[2];
	    }
	    return null;
	  },
	  parse: function parse(link) {
	    var me = this,
	        sku = null,
	        returnUrl = link;
	
	    if (me.isWQ()) {
	      // 微信
	      if (link.indexOf('//m.jd.com/product/') !== -1 || link.indexOf('//item.m.jd.com/') !== -1 || link.indexOf('//mitem.jd.hk') !== -1 || link.indexOf('//item.jd.hk') !== -1 || link.indexOf('//item.jd.com') !== -1) {
	        // 商详页
	        var skuId = me.getUrlParam(link, 'wareId');
	        if (!skuId) {
	          var linkArr = link.split('/');
	          skuId = linkArr[linkArr.length - 1].split('.')[0];
	        }
	        return '//wqitem.jd.com/item/view?sku=' + skuId;
	      }
	
	      if (link.indexOf('//pro.m.jd.com') !== -1) {
	        //通天塔活动页
	        return link.replace('/mall/', '/wq/');
	      }
	
	      return link;
	    } else {
	      // 非微信
	      return link;
	    }
	  }
	  // ,
	  // parseAreaLink: function($area){
	  //   var me=this;
	  //   var $links=$area.find('a');
	  //   $links.each(function(){
	  //     $link=$(this);
	  //     $link.attr('href',me.parse($link.attr('href')));
	  //   })
	  // }
	};
	
	module.exports = linkParser;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var priceModel = __webpack_require__(21);
	
	    var price = {
	        skuArry: [],
	        pageNum: 40,
	        timeNow: null,
	        init: function init(tag) {
	            var self = this;
	            tag = tag || "";
	
	            if ($("#priceQuerySwitch").val() == "ON") {
	                self.getPrice(tag);
	            }
	        },
	        unique: function unique(arr) {
	            var result = [],
	                hash = {};
	            for (var i = 0, elem; (elem = arr[i]) != null; i++) {
	                if (!hash[elem]) {
	                    result.push(elem);
	                    hash[elem] = true;
	                }
	            }
	            return result;
	        },
	        getPrice: function getPrice(tag) {
	            var self = this;
	            var skuList = "";
	            self.skuArry = [];
	            //所有的skuid
	            $("[skuid]").each(function () {
	                if (!$(this).hasClass("priceLoad")) {
	                    skuList = skuList + "," + $(this).attr("skuid");
	                }
	            });
	
	            skuList = skuList.substring(1, skuList.length);
	            skuList = skuList.split(",");
	
	            skuList = self.unique(skuList);
	
	            var num = Math.ceil(skuList.length / self.pageNum);
	
	            for (var i = 1; i <= num; i++) {
	                var skuids = "";
	                for (var j = (i - 1) * self.pageNum; j < i * self.pageNum; j++) {
	                    if (typeof skuList[j] != "undefined") {
	                        skuids = skuids + "," + skuList[j];
	                    } else {
	                        continue;
	                    }
	                }
	                skuids = skuids.substring(1, skuids.length);
	
	                if (skuids != "") {
	                    self.skuArry.push(skuids);
	                }
	            }
	
	            if (self.skuArry.length == 0) {
	                return false;
	            }
	            for (var i = 0; i < self.skuArry.length; i++) {
	                if (tag == "seckill") {
	                    self.ajaxSecKillPrice(self.skuArry[i]);
	                } else if (tag == "pcpPrice") {
	                    self.ajaxPcpPrice(self.skuArry[i]);
	                } else {
	                    self.ajaxPrice(self.skuArry[i]);
	                }
	            }
	        },
	        ajaxPrice: function ajaxPrice(skuids) {
	            var self = this;
	            var arg = {
	                "skuids": skuids,
	                "origin": 2,
	                "source": "globalbuy"
	            };
	            var skuArray = skuids.split(',');
	            var leftSkuArray = skuArray.slice();
	
	            priceModel.ajaxGetPrice(arg, function (data) {
	                var length = skuArray.length;
	                for (var i = 0; i < length; i++) {
	                    var element = skuArray[i];
	                    $.each(data, function () {
	                        /**
	                         ** this.id是调用接口返回的skuid
	                         ** element是页面上的skuid
	                         ** thisObj是根据页面上的skuid找到的节点
	                         **/
	                        var newPrice = priceModel.formatPrice(this.p);
	                        var oldPrice = priceModel.formatPrice(this.m);
	
	                        var samPrice = null;
	                        if (this.sp) {
	                            samPrice = priceModel.formatPrice(this.sp);
	                        }
	
	                        var thisObj = $("[skuid='" + element + "']");
	
	                        thisObj.addClass("priceLoad");
	
	                        if (element === this.id && newPrice != "-1" && oldPrice != "-1") {
	                            thisObj.find(".price span").text("¥" + newPrice);
	                            thisObj.find(".price del").text("¥" + oldPrice);
	
	                            var samDiv = thisObj.find(".sam");
	                            if (samDiv.length > 0 && samPrice !== null) {
	                                samDiv.html("\n                                    <div class=\"p-sam\">&yen;" + samPrice + "</div>\n                                    <i class=\"logo\"></i>\n                                ");
	                            }
	
	                            var discount = priceModel.getDiscount(newPrice, oldPrice);
	                            if (discount != "") {
	                                thisObj.find(".discount").text(discount + "折");
	                            } else {
	                                thisObj.find(".discount").remove();
	                            }
	                            var ind = leftSkuArray.indexOf(element);
	                            if (ind >= 0) {
	                                leftSkuArray.splice(ind, 1);
	                            }
	                            return;
	                        }
	                    });
	                }
	                ;
	
	                if (leftSkuArray.length > 0) {
	                    leftSkuArray.forEach(function (element, _index) {
	                        var thisObj = $("[skuid='" + element + "']");
	                        thisObj.find(".price span").text("暂无价格").css({
	                            "font-size": ".6rem"
	                        });
	                        thisObj.find(".discount").remove();
	                        if (thisObj.find("em")) {
	                            thisObj.find("em").remove();
	                        }
	                        return;
	                    });
	                }
	            });
	        },
	        ajaxSecKillPrice: function ajaxSecKillPrice(skuids) {
	            var self = this;
	            var arg = {
	                "skuids": skuids,
	                "origin": 2,
	                "source": "globalbuy"
	            };
	            var skuArray = skuids.split(',');
	            var leftSkuArray = skuArray.slice();
	
	            priceModel.ajaxGetPrice(arg, function (data) {
	                var skuArray = skuids.split(",");
	                var cbData = [];
	                var existedArray = [];
	                $(data).each(function () {
	                    cbData.push(this.id);
	                });
	
	                for (var i = 0; i < skuArray.length; i++) {
	                    var skuid = skuArray[i];
	                    if (existedArray.indexOf(skuid) > -1) {
	                        continue;
	                    }
	                    existedArray.push(skuid);
	
	                    var num = cbData.indexOf(skuid);
	
	                    if (num > -1) {
	                        var skuObj = $("dd[skuid='" + skuid + "']");
	
	                        var newPrice = priceModel.formatPrice(data[num].p);
	                        var oldPrice = priceModel.formatPrice(data[num].m);
	
	                        skuObj.each(function () {
	                            var _this = $(this);
	                            if (_this.parents(".tabCnt").attr("id") == "begining") {
	                                if (newPrice == "-1") {
	                                    _this.find(".price span").text("暂无价格").css({
	                                        "font-size": ".6rem"
	                                    });
	                                    _this.find(".discount").remove();
	                                    if (_this.find("em")) {
	                                        _this.find("em").remove();
	                                    }
	                                    return true;
	                                } else {
	                                    _this.find(".price span").text("¥" + newPrice);
	                                }
	                            } else {
	                                if (newPrice == "-1") {
	                                    _this.find(".price span").text("暂无价格").css({
	                                        "font-size": ".6rem"
	                                    });
	                                    _this.find(".discount").remove();
	                                    if (_this.find("em")) {
	                                        _this.find("em").remove();
	                                    }
	                                    return true;
	                                } else if (newPrice.length == 1) {
	                                    _this.find(".price span").text("¥?");
	                                } else {
	                                    _this.find(".price span").text("¥?" + newPrice.substring(1, newPrice.length));
	                                }
	                            }
	
	                            _this.find("del").text("¥" + oldPrice).before($("<em>参考价:</em>"));
	
	                            var discount = priceModel.getDiscount(newPrice, oldPrice);
	                            if (discount != "") {
	                                _this.find(".discount").text(discount + "折");
	                            } else {
	                                _this.find(".discount").remove();
	                            }
	                        });
	                    }
	                }
	            });
	        },
	        ajaxPcpPrice: function ajaxPcpPrice(skuids) {
	            var self = this;
	            var arg = {
	                "skuids": skuids,
	                "origin": 2,
	                "source": "globalbuy"
	            };
	            var skuArray = skuids.split(',');
	            var leftSkuArray = skuArray.slice();
	
	            priceModel.ajaxGetPcpPrice(arg, function (data) {
	                var length = skuArray.length;
	                for (var i = 0; i < length; i++) {
	                    var element = skuArray[i];
	                    $.each(data, function () {
	                        /**
	                         ** this.id是调用接口返回的skuid
	                         ** element是页面上的skuid
	                         ** thisObj是根据页面上的skuid找到的节点
	                         **/
	                        var newPrice = priceModel.formatPrice(this.p);
	                        var oldPrice = priceModel.formatPrice(this.m);
	                        var pcpPrice = priceModel.formatPrice(this.pcp);
	
	                        var cheaper = -1;
	
	                        //console.log('newPrice: ', newPrice, 'oldPrice:', oldPrice, 'pcpPrice:', pcpPrice);
	
	                        var thisObj = $("[skuid='" + element + "']");
	
	                        thisObj.addClass("priceLoad");
	
	                        if (element === this.id && newPrice != "-1" && oldPrice != "-1") {
	                            thisObj.find(".price span").text("¥" + newPrice);
	                            thisObj.find(".price del").text("¥" + oldPrice);
	
	                            var discount = priceModel.getDiscount(newPrice, oldPrice);
	                            if (discount != "") {
	                                thisObj.find(".discount").text(discount + "折");
	                            } else {
	                                thisObj.find(".discount").remove();
	                            }
	                            var ind = leftSkuArray.indexOf(element);
	                            if (ind >= 0) {
	                                leftSkuArray.splice(ind, 1);
	                            }
	
	                            if (pcpPrice > 0) {
	                                cheaper = pcpPrice - newPrice;
	                            }
	
	                            if (cheaper.toString().length > 2 && cheaper % 1 !== 0) {
	                                cheaper = parseInt(cheaper.toFixed(2));
	                            }
	                            if (cheaper > 0) {
	                                thisObj.find('.compare .num').html(cheaper);
	                                thisObj.find('.compare').removeClass('hide');
	                            }
	                            //设置背景颜色
	                            if ($('#background').val()) {
	                                thisObj.find('.compare').css('background-color', $('#background').val());
	                                thisObj.find(".price span").css('color', $('#background').val());
	                            }
	
	                            return;
	                        }
	                    });
	                }
	                ;
	
	                if (leftSkuArray.length > 0) {
	                    leftSkuArray.forEach(function (element, _index) {
	                        var thisObj = $("[skuid='" + element + "']");
	                        thisObj.find(".price span").text("暂无价格").css({
	                            "font-size": ".6rem"
	                        });
	                        if ($('#background').val()) {
	                            thisObj.find(".price span").css('color', $('#background').val());
	                        }
	                        thisObj.find(".discount").remove();
	                        if (thisObj.find("em")) {
	                            thisObj.find("em").remove();
	                        }
	                        return;
	                    });
	                }
	            });
	        }
	    };
	    exports.fn = price;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(4);
	    var priceModel = {
	        ajaxGetPrice: function ajaxGetPrice(data, _success, error) {
	            $.ajax({
	                url: Config.serviceInterface.getPrice,
	                data: data,
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success)) {
	                        _success(data);
	                    }
	                }
	            });
	        },
	        ajaxGetPcpPrice: function ajaxGetPcpPrice(data, _success2, error) {
	            $.ajax({
	                url: Config.serviceInterface.getPcpPrice,
	                data: data,
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success2)) {
	                        _success2(data);
	                    }
	                }
	            });
	        },
	        ajaxGetTime: function ajaxGetTime(data, _success3, error) {
	            $.ajax({
	                url: Config.serviceInterface.getTime,
	                data: {},
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success3)) {
	                        _success3(data);
	                    }
	                }
	            });
	        },
	        getDiscount: function getDiscount(newPrice, oldPrice) {
	            var newPrice = newPrice * 10000;
	            var oldPrice = oldPrice * 10000;
	            var result = newPrice / oldPrice;
	
	            var discount = Math.ceil(Math.floor(result * 1000) / 10) / 10;
	            if (discount > 9.9) {
	                discount = "";
	            } else if (discount < 0.1) {
	                discount = 0.1;
	            } else {
	                discount = discount.toFixed(1);
	                if (discount.substring(discount.length - 1, discount.length) == "0") {
	                    discount = discount.substring(0, discount.length - 2);
	                }
	            }
	
	            return discount;
	        },
	        formatPrice: function formatPrice(price) {
	            price = price || "";
	            var arr = price.split(".");
	            if (arr.length == 2) {
	                if (arr[1] == "00") {
	                    return arr[0];
	                } else if (arr[1] == "0000") {
	                    return arr[0];
	                } else if (arr[1].indexOf("0") == arr[1].length - 1) {
	                    return price.substring(0, price.length - 1);
	                } else {
	                    return price;
	                }
	            } else {
	                return price;
	            }
	        }
	    };
	    module.exports = priceModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var lazyload = __webpack_require__(10);
	    var tab = {
	        f: [],
	        //selfObj: 自定义对象，允许在参数中传一个自定义对象
	        tapEvent: function tapEvent(className, startFn, moveFn, endFn, selfObj) {
	            var self = this;
	            self.f.lastOffsetX = 0;
	
	            if (typeof jQuery != "undefined") {
	                jQuery.noConflict();
	            }
	
	            $(className).on("touchstart", function (e) {
	                if (selfObj) {
	                    self.f.lastOffsetX = selfObj.getWrapperTranslate('x');
	                }
	
	                if ($.isFunction(startFn)) {
	                    startFn(e, self);
	                } else {
	                    self.defaultCallback_start(e, self);
	                }
	            }).on("touchmove", function (e) {
	                if ($.isFunction(moveFn)) {
	                    moveFn(e, self);
	                } else {
	                    self.defaultCallback_move(e, self);
	                }
	            }).on("touchend", function (e) {
	                var _this = $(this);
	                if ($.isFunction(endFn)) {
	                    endFn(e, _this, self, selfObj);
	                } else {
	                    self.defaultCallback_end(e, _this, self, selfObj);
	                }
	            });
	        },
	        justTap: function justTap() {
	            var self = this;
	            self.tapEvent(".tabs ul li", "", "", self.normal_tab);
	        },
	        normal_tab: function normal_tab(e, _this, self) {
	            var self = self;
	
	            if (self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {} else {
	                _this.parent().children().removeClass("curr");
	                _this.addClass("curr");
	
	                var idx = _this.attr("tab-idx");
	                var tabCnts = _this.parent().parent().children(".tabCnt");
	                tabCnts.addClass("hide");
	
	                tabCnts.each(function () {
	                    if ($(this).attr("cnt-idx") == idx) {
	                        $(this).removeClass("hide");
	                        return false;
	                    }
	                });
	
	                lazyload.fn.init();
	            }
	        },
	        defaultCallback_start: function defaultCallback_start(e, self) {
	            var self = self;
	
	            self.f.startX = e.touches[0].clientX;
	            self.f.endX = e.touches[0].clientX;
	            self.f.prevX = self.f.startX;
	            self.f.prevY = e.touches[0].clientY;
	            self.f.directionX = "";
	            self.f.directionY = "";
	        },
	        defaultCallback_move: function defaultCallback_move(e, self) {
	            var self = self;
	
	            if (e.touches.length > 0) {
	                self.f.directionX = e.touches[0].clientX - self.f.prevX > 0 ? "right" : "left";
	                self.f.directionY = e.touches[0].clientY - self.f.prevY > 0 ? "bottom" : "top";
	            } else {
	                self.f.directionX = "";
	                self.f.directionY = "";
	            }
	        },
	        defaultCallback_end: function defaultCallback_end(e, _this, self, selfObj) {
	            var self = self;
	
	            if (self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {} else {
	                _this.parent().children().removeClass("curr");
	                _this.addClass("curr");
	
	                var idx = _this.attr("tab-idx");
	                var tabCnts = _this.parent().parent().parent().children(".tabCnt");
	                tabCnts.addClass("hide");
	
	                tabCnts.each(function () {
	                    if ($(this).attr("cnt-idx") == idx) {
	                        $(this).removeClass("hide");
	                        return false;
	                    }
	                });
	
	                self.setPosition(_this, self, selfObj);
	                lazyload.fn.init();
	            }
	        },
	        autoSelected: function autoSelected(_this, selfObj) {
	            var self = this;
	
	            _this.parent().children().removeClass("curr");
	            _this.addClass("curr");
	
	            var wrapper = _this.parent().parent();
	            var dlObj = wrapper.find("dl");
	            var ddObj = wrapper.find("dd");
	
	            var ddOffsetX = _this.offset().left - $("body").offset().left;
	            var middle = wrapper.width() / 2 - _this.width() / 2;
	
	            var totalLength = 0;
	            ddObj.each(function () {
	                var ddWidth = _this[0].style.width;
	                ddWidth = parseFloat(ddWidth.substring(0, ddWidth.length - 2));
	
	                totalLength = totalLength + ddWidth;
	            });
	
	            var offsetLength = totalLength - wrapper.width();
	
	            if (offsetLength <= 0) {
	                return false;
	            }
	
	            var lastOffsetX = self.f.lastOffsetX || 0;
	
	            var moveX = middle - ddOffsetX + lastOffsetX;
	
	            if (moveX < -offsetLength) {
	                moveX = -offsetLength;
	            } else if (moveX > 0) {
	                moveX = 0;
	            }
	
	            self.f.lastOffsetX = moveX;
	
	            dlObj.css({
	                "transition-duration": "300ms",
	                "-webkit-transition-duration": "300ms",
	                "-moz-transition-duration": "300ms",
	                "-o-transition-duration": "300ms"
	            });
	
	            selfObj.setWrapperTranslate(moveX);
	        },
	        setPosition: function setPosition(_this, self, selfObj) {
	            var wrapper = _this.parent().parent();
	            var dlObj = wrapper.find("dl");
	            var ddObj = wrapper.find("dd");
	
	            var ddOffsetX = _this.offset().left - $("body").offset().left;
	            var middle = wrapper.width() / 2 - _this.width() / 2;
	
	            var totalLength = 0;
	            ddObj.each(function () {
	                var ddWidth = _this[0].style.width;
	                ddWidth = parseFloat(ddWidth.substring(0, ddWidth.length - 2));
	
	                totalLength = totalLength + ddWidth;
	            });
	
	            var offsetLength = totalLength - wrapper.width();
	
	            if (offsetLength <= 0) {
	                return false;
	            }
	
	            var moveX = middle - ddOffsetX + self.f.lastOffsetX;
	
	            if (moveX < -offsetLength) {
	                moveX = -offsetLength;
	            } else if (moveX > 0) {
	                moveX = 0;
	            }
	
	            self.f.lastOffsetX = moveX;
	
	            dlObj.css({
	                "transition-duration": "300ms",
	                "-webkit-transition-duration": "300ms",
	                "-moz-transition-duration": "300ms",
	                "-o-transition-duration": "300ms"
	            });
	
	            selfObj.setWrapperTranslate(moveX);
	        }
	    };
	
	    module.exports = tab;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tpl = '<% if(pageNum == 1) { %>' + '<div class="mask hide">' + '<img src="//static.360buyimg.com/globalwide/dist/v20160412/i/loading.gif">' + '<div class="nomore-tip hide">该类目暂无商品展示</div>' + '</div>' + '<% } %>' + '<% for(i = 0; i < goods.length; i++) { %>' + '<a skuid = "<%= goods[i].skuText %>" ' + 'class="block tapItem"' + 'clstag="<%== goods[i].clsTag %>">' + '<% if(goods[i].imgLogo) { %>' + '<img src="" class="conner lazy" dataimg="<%== goods[i].imgLogo %>">' + '<% } %>' + '<img src="" class="m-img lazy" dataimg="<%== goods[i].skuImg %>">' + '<div class="compare hide">比PC端省<span class="num"> </span>元</div>' + '<div class="name"><%== goods[i].itemText %></div>' + '<div class="price">' + '<span></span>' + '</div>' + '</a>' + '<% } %>';
	    exports.tpl = tpl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tplModel = __webpack_require__(11);
	    var price = __webpack_require__(20);
	    var lazyload = __webpack_require__(10);
	    var tapEvent = __webpack_require__(13);
	    var Config = __webpack_require__(4);
	    var tabModel = __webpack_require__(24);
	
	    var bottomCatSwiper = {
	        loadMoreFlag: new Array(),
	        PAGE_SIZE: 20,
	        init: function init() {
	            var self = this;
	
	            if ($(".more").length) {
	
	                var columnTabNum = $(".columnTab dl dd").length;
	                var previewCnt = 1;
	                if (columnTabNum <= 4) {
	                    previewCnt = columnTabNum;
	                } else {
	                    previewCnt = 4.5;
	                }
	
	                var bottomCat = new Swiper(".columnTab", {
	                    slidesPerView: previewCnt,
	                    freeMode: true,
	                    lazyLoading: true,
	                    freeModeSticky: false
	                });
	
	                //一级分类tab标签点击事件
	                tabModel.tapEvent(".more .tabs dd", "", "", bottomCatSwiper.firstClassTapEvt, bottomCat);
	                //二级分类tab标签点击事件
	                tabModel.tapEvent(".more .tabs .second-cat .name", "", "", bottomCatSwiper.secondClassTapEvt, bottomCat);
	
	                //when loading page for the first time, judge if the data is from config or search
	                //goods are begin with tag a, so we select by children('a')
	                var node = $(".more .tabs").find('[cnt-idx="1"] .curr');
	                node.data('pageNum', 1);
	                if ($('.more .tabs .goods').children('a').length > 0) {
	                    node.data('isFromConfig', true);
	                } else {
	                    node.data('isFromConfig', false);
	                    var evt = { type: 'touchend' };
	                    bottomCatSwiper.searchGoods(node.attr('classid'), node.html(), 1, node, evt, node.attr('categoryid'));
	                }
	
	                bottomCatSwiper.initScrollLoading();
	
	                jQuery(document).on('scroll', function () {
	                    if ($(".more .tabs").length) {
	                        bottomCatSwiper.firstCatToTopOrNot();
	                    }
	                });
	            }
	        },
	        firstClassTapEvt: function firstClassTapEvt(e, _this, self, selfObj) {
	            if (self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {} else {
	                //设置一级分类背景色
	                _this.siblings().removeClass('curr');
	                if (!_this.hasClass('curr')) {
	                    _this.addClass('curr');
	                }
	
	                //找到它下面的对应节点
	                var tabIndex = _this.attr('tab-idx');
	                var node = $(".more .tabs").find('[cnt-idx="' + tabIndex + '"]');
	                node.siblings('.tabCnt').not('.hide').addClass('hide');
	
	                //显示二级标签，若一级分类下面只有一个二级分类，则不显示此二级分类。
	                if (node.children().children().length > 1) {
	                    node.removeClass('hide');
	                }
	
	                //将页面滚动到tab顶部
	                bottomCatSwiper.scrollToTabTop(_this);
	
	                self.setPosition(_this, self, selfObj);
	
	                //Trigger tap envet
	                bottomCatSwiper.secondClassTapEvt(e, node.children().children().first(), self, selfObj);
	            }
	        },
	
	        secondClassTapEvt: function secondClassTapEvt(e, _this, self, selfObj) {
	            if (self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {} else {
	                _this.addClass('curr').removeAttr('pageNum').siblings().removeClass('curr').css('color', '');
	                bottomCatSwiper.getGoodsByCatIdorSearch(_this, e);
	            }
	        },
	
	        getGoodsByCatIdorSearch: function getGoodsByCatIdorSearch(node, evt) {
	            var catId = node.attr('categoryid');
	            var pageNum = 1;
	            var classid = node.attr('classid');
	            var catName = node.html();
	
	            if (evt.type === 'touchend') {
	                bottomCatSwiper.loadMoreFlag = new Array();
	                bottomCatSwiper.loadMoreFlag[catId] = new Array();
	                node.data('noMore', false);
	                pageNum = 1;
	                bottomCatSwiper.showLoading();
	                //如果是用户点击，记录请求时间到节点，以便数据返回时判断是否是最新数据。
	                //如果不是最新数据，则不渲染
	                bottomCatSwiper.recordReqTime(node);
	            } else {
	                pageNum = node.data('pageNum') >= 1 ? node.data('pageNum') + 1 : 1;
	            }
	
	            //var loadMoreFlag = bottomCatSwiper.loadMoreFlag;
	            if (bottomCatSwiper.loadMoreFlag[catId] === undefined) {
	                bottomCatSwiper.loadMoreFlag[catId] = new Array();
	            }
	
	            // we don't know the data is from our backend config or not
	            if (node.data('isFromConfig') === undefined && !bottomCatSwiper.loadMoreFlag[catId][pageNum]) {
	                //console.log('not sure where to get data.. ');
	
	                bottomCatSwiper.loadMoreFlag[catId][pageNum] = true;
	
	                bottomCatSwiper.getGoodsFromConfig(catId, pageNum, bottomCatSwiper.PAGE_SIZE, node, evt);
	            } else if (node.data('isFromConfig')) {
	                if (!bottomCatSwiper.loadMoreFlag[catId][pageNum] && !node.data('noMore')) {
	                    //console.log('sure it is from bk, retriving data , pageNum: ', pageNum);
	                    bottomCatSwiper.loadMoreFlag[catId][pageNum] = true;
	                    bottomCatSwiper.getGoodsFromConfig(catId, pageNum, bottomCatSwiper.PAGE_SIZE, node, evt);
	                }
	            } else if (!node.data('isFromConfig') && !node.data('noMore')) {
	                //console.log('sure it is from search ....');
	                if (!bottomCatSwiper.loadMoreFlag[catId][pageNum] && !node.data('noMore')) {
	                    bottomCatSwiper.loadMoreFlag[catId][pageNum] = true;
	                    bottomCatSwiper.searchGoods(classid, catName, pageNum, node, evt, catId);
	                    node.data('isFromConfig', false);
	                }
	            }
	        },
	
	        getGoodsFromConfig: function getGoodsFromConfig(catId, pageNum, pageSize, node, evt) {
	            //console.log('get goods from config');
	
	            var params = {
	                cateId: catId,
	                pageNo: pageNum,
	                pageSize: pageSize,
	                sign: $("#sign").val()
	            };
	
	            $.ajax({
	                url: Config.serviceInterface.getZyLoadMore,
	                data: params,
	                method: "get",
	                dataType: 'json'
	            }).done(function (ret) {
	                if (ret.success && ret.result && ret.result.selfChannelCategorySpecialGoods.length > 0) {
	                    data = ret.result.selfChannelCategorySpecialGoods;
	                    bottomCatSwiper.renderData(data, evt.type, node);
	                    node.data('isFromConfig', true);
	                    node.data('pageNum', pageNum);
	
	                    if (data.length < pageSize) {
	                        bottomCatSwiper.loadMoreFlag[catId][pageNum] = false;
	                        node.data('noMore', true);
	                    }
	                } else if (ret.result && ret.result.selfChannelCategorySpecialGoods.length === 0 && !node.data('isFromConfig')) {
	                    //如果从后台加载过来没有数据，再从搜索接口加载.
	                    //If no data configered from our backend, then load data from search api
	                    //console.log('there is not configering data, retriving data from search apis');
	                    bottomCatSwiper.searchGoods(node.attr('classid'), node.html(), pageNum, node, evt, catId);
	                    node.data('isFromConfig', false);
	                } else if (node.data('pageNum') == 1 && pageNum != 2 || !ret.success) {
	                    //当前页数是第一页，且加载的页数是第二页的时候，没有出来出具，也不渲染成空的
	                    bottomCatSwiper.showNomoreTip();
	                }
	                bottomCatSwiper.firstCatToTopOrNot();
	            });
	        },
	
	        //classid 为搜索用到的品类id
	        //catId 仅仅用于记录当前页是否被请求
	        searchGoods: function searchGoods(classid, catName, pageNum, node, evt, catId) {
	            var params = {
	                promotion: "",
	                delivery: "",
	                ev: "",
	                sort: "sort_default_desc",
	                page: pageNum,
	                self: 1
	            };
	
	            if (classid != null && classid.length) {
	                params.cat = classid;
	            } else {
	                params.searchkey = catName;
	            }
	
	            //console.log('ajax call begin');
	            if (pageNum === 1) {
	                bottomCatSwiper.showLoading();
	            }
	
	            $.ajax({
	                url: Config.serviceInterface.searchGoodsByCat,
	                method: "get",
	                dataType: 'json',
	                data: params
	            }).done(function (data) {
	                if (data) {
	                    var items = bottomCatSwiper.convertToItemsArray(data);
	                    //if(items.length > 0 || pageNum === 1) {
	                    node.data('pageNum', pageNum);
	                    //}
	                    bottomCatSwiper.renderData(items, evt.type, node);
	                }
	                if (data && data.items.length < bottomCatSwiper.PAGE_SIZE) {
	                    bottomCatSwiper.loadMoreFlag[catId][pageNum] = false;
	                    node.data('noMore', true);
	                }
	                bottomCatSwiper.firstCatToTopOrNot();
	            });
	        },
	
	        initScrollLoading: function initScrollLoading() {
	            $(window).scroll(function (evt) {
	                var scrollToLoadHeight = $(document).height() - 50 * parseInt($("html").css("font-size"));
	                if ($(window).scrollTop() + $(window).height() > scrollToLoadHeight) {
	                    var cntIdx = $('.more .tabs .swiper-wrapper dd.curr').attr('tab-idx');
	                    var currCatNode = bottomCatSwiper.getCurrSecondCatNode(cntIdx);
	                    bottomCatSwiper.getGoodsByCatIdorSearch($(currCatNode), evt);
	                }
	            });
	        },
	
	        renderData: function renderData(data, type, node) {
	            var goodsDiv = $('.more .tabs .goods');
	            var pageNum = node.data('pageNum');
	            var tpl = __webpack_require__(27);
	            var html = tplModel.render({ goods: data, pageNum: pageNum }, tpl);
	            if (type === 'touchend') {
	                //如果为点击事件，则肯定请求的是第一页
	                //有数据回来的时候，请求时间和节点记录的时间一致才渲染
	                if (node.data('reqTime') === goodsDiv.data('reqTime')) {
	                    goodsDiv.html(html);
	                    if (data.length === 0 && pageNum == 1) {
	                        bottomCatSwiper.showNomoreTip();
	                    }
	                } else {}
	            } else if (type === 'scroll') {
	                if (node.data('reqTime') === goodsDiv.data('reqTime')) {
	                    //如果是滚动事件，有数据回来的且为第一页，提示没有跟多，否则渲染数据。
	                    if (data.length === 0 && pageNum == 1) {
	                        bottomCatSwiper.showNomoreTip();
	                    } else {
	                        goodsDiv.append(html);
	                    }
	                } else {
	                    //如果是用户的滚动事件, 发送请求的时间和商品节点上的时间不一样，
	                    //而且又是第一页的时候，直接丢弃结果不渲染
	                    if (pageNum == 1) {} else {
	                        goodsDiv.append(html);
	                    }
	                }
	            }
	
	            price.fn.init('pcpPrice');
	            lazyload.fn.init();
	            tapEvent.tapItem();
	        },
	
	        convertToItemsArray: function convertToItemsArray(data) {
	            if (!data || !data.items || data.items.length < 0) {
	                return [];
	            };
	
	            var ret = data.items.map(function (item) {
	                return {
	                    itemText: item.skuName,
	                    skuImg: item.skuImage,
	                    skuText: item.skuId
	                };
	            });
	            //console.log(ret);
	            return ret;
	        },
	
	        scrollToTabTop: function scrollToTabTop(node, prevHeight) {
	
	            if ($(".tabs").hasClass('fixed')) {
	
	                secondcatNode = bottomCatSwiper.getFirstChildByCntIdx(node.attr('tab-idx')).parent().parent();
	
	                //如果一级分类下面的二级分类是hide了的，先将它取消掉，以免影响高度
	                var isSecondcatHide = secondcatNode.hasClass('hide');
	                if (isSecondcatHide) {
	                    secondcatNode.removeClass('hide').removeClass('hide');
	                }
	                var thisHeight = node.height();
	                var idx = node.attr('tab-idx');
	                var distanceTop = $("div[cnt-idx='" + idx + "']").offset().top;
	                $("body").scrollTop(distanceTop - thisHeight);
	                if (isSecondcatHide) {
	                    secondcatNode.addClass('hide');
	                }
	                $(".more .tabs").removeClass("fixed");
	            }
	        },
	
	        getFirstChildByCntIdx: function getFirstChildByCntIdx(idx) {
	            var node = $("div[cnt-idx='" + idx + "']");
	            return node.children().children().first();
	        },
	
	        getCurrSecondCatNode: function getCurrSecondCatNode(idx) {
	            var node = $("div[cnt-idx='" + idx + "']");
	            return node.children().children('.curr');
	        },
	
	        showLoading: function showLoading() {
	            $('.more .goods').children('a').remove();
	            var maskNode = $('.more .tabs .goods .mask');
	            var loadingImg = maskNode.children('img');
	            var tipNode = maskNode.children('.nomore-tip');
	
	            if (maskNode.hasClass('hide')) {
	                maskNode.removeClass('hide');
	            }
	
	            if (loadingImg.hasClass('hide')) {
	                loadingImg.removeClass('hide');
	            }
	
	            if (!tipNode.hasClass('hide')) {
	                tipNode.addClass('hide');
	            }
	        },
	
	        hideLoading: function hideLoading() {
	            var maskNode = $('.more .tabs .goods .mask');
	            if (!maskNode.hasClass('hide')) {
	                maskNode.addClass('hide');
	            }
	        },
	
	        showNomoreTip: function showNomoreTip() {
	            $('.more .goods').children('a').remove();
	            var maskNode = $('.more .tabs .goods .mask');
	            var loadingImg = maskNode.children('img');
	            var tipNode = maskNode.children('.nomore-tip');
	
	            if (maskNode.hasClass('hide')) {
	                maskNode.removeClass('hide');
	            }
	
	            if (!loadingImg.hasClass('hide')) {
	                loadingImg.addClass('hide');
	            }
	
	            if (tipNode.hasClass('hide')) {
	                tipNode.removeClass('hide');
	            }
	        },
	
	        hideNomoreTip: function hideNomoreTip() {
	            bottomCatSwiper.hideLoading();
	        },
	
	        recordReqTime: function recordReqTime(node) {
	            var goodDiv = $('.goods');
	            var timeStamp = new Date().getTime();
	            goodDiv.data('reqTime', timeStamp);
	            node.data('reqTime', timeStamp);
	        },
	
	        firstCatToTopOrNot: function firstCatToTopOrNot() {
	            if ($("body").scrollTop() - $(".more .tabs").offset().top >= 0) {
	                if (!$(".more .tabs").hasClass("fixed")) {
	                    $(".more .tabs").addClass("fixed");
	                }
	            } else {
	                $(".more .tabs").removeClass("fixed");
	            }
	        }
	    };
	
	    module.exports = bottomCatSwiper;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /js/selfchannel.js